import { SafeUrl } from '@angular/platform-browser';

export class WeblinkAttachmentFile{
    Url: SafeUrl;
    MimeType:string;
    u:string;
    b:Blob;
}